import { put, takeEvery, all } from 'redux-saga/effects';
import * as constants from '../constants/storageManagement';
import * as storageManagementPageActions from '../actions/storageManagement';
import { Log } from 'ng2-logger';
import { Common } from '../../core/common';
import { StorageManagementService } from '../../api/storage-management';
import * as coreActions from '../actions/core';
import { Notification } from '../../components/notification/main';
import Translator from '../../core/i18n';
import { param } from 'jquery';

const T = Translator.create();
const _logger = Log.create('storage_management_sagas');
const _storageManagementService = new StorageManagementService();

function* getGeneralStatistics(params: any) {
    let isError = false;
    let errorList: any;
    let pageData: any;
    try {
        yield _storageManagementService.RequestGetGeneralStatisticsAsync({ ...params.filters, ...params.paging })
            .then((responseData: Response) => {
                return responseData;
            })
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                }
                return responseData.json();
            }).then((response) => {
                if (isError) {
                    errorList = response;
                } else {
                    pageData = response;
                }
            });

        if (!isError) {
            yield put(storageManagementPageActions.SetGeneralStatistics(pageData, params.spinnerId ? params.spinnerId : '', 'set'));
        } else {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
        }

        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
    } catch (error: any) {
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
        Notification.setNotification('error', error, 'topRight');
    }
}

function* getFilesAddedActivitiesStatistics(params: any) {
    let isError = false;
    let errorList: any;
    let pageData: any;
    try {
        yield _storageManagementService.RequestGetFilesAddedActivitiesStatisticsAsync({ ...params.filters, ...params.paging })
            .then((responseData: Response) => {
                return responseData;
            })
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                }
                return responseData.json();
            }).then((response) => {
                if (isError) {
                    errorList = response;
                } else {
                    pageData = response;
                }
            });

        if (!isError) {
            yield put(storageManagementPageActions.SetFilesAddedActivitiesStatistics(pageData, params.spinnerId ? params.spinnerId : '', 'set'));
        } else {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
        }

        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
    } catch (error: any) {
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
        Notification.setNotification('error', error, 'topRight');
    }
}

function* getActivityFilesStatisticsByTerm(params: any) {
    let isError = false;
    let errorList: any;
    let pageData: any;
    try {
        yield _storageManagementService.RequestGetActivityFilesStatisticsByTermAsync({ termId: params.termId })
            .then((responseData: Response) => {
                return responseData;
            })
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                }
                return responseData.json();
            }).then((response) => {
                if (isError) {
                    errorList = response;
                } else {
                    pageData = response;
                }
            });

        if (!isError) {
            yield put(storageManagementPageActions.SetActivityFilesStatisticsByTerm(pageData, params.spinnerId ? params.spinnerId : '', 'set'));
        } else {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
        }

        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
    } catch (error: any) {
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
        Notification.setNotification('error', error, 'topRight');
    }
}

function* getActivityFilesListByTerm(params: any) {
    let isError = false;
    let errorList: any;
    let pageData: any;
    try {
        yield _storageManagementService.RequestGetActivityFilesListByTermAsync({ ...params.filters, ...params.paging })
            .then((responseData: Response) => {
                return responseData;
            })
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                }
                return responseData.json();
            }).then((response) => {
                if (isError) {
                    errorList = response;
                } else {
                    pageData = response;
                }
            });

        if (!isError) {
            if(params.callback)
            {
                 params.callback();
            }
            yield put(storageManagementPageActions.SetActivityFilesListByTerm(pageData, params.filters.tabName ? params.filters.tabName : '', params.spinnerId ? params.spinnerId : '', 'set'));
        } else {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
        }

        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
    } catch (error: any) {
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
        Notification.setNotification('error', error, 'topRight');
    }
}

function* deleteActivityFiles(params: any) {
    let isError = false;
    let errorList: any;
    let pageData: any;
    let S3IdList = params.selectedIds;
    let IsDeleting: boolean = true;
    let isAllSelected = params.isAllSelected;
    let listName = params.listName;
    let tabName = params.tabName;
    let termId = params.termId;
    let isDeleted = params.isDeleted;
    let fileName = params.fileName;
    let fileOwner = params.fileOwner;
    let fileDate = params.fileDate;
    let fileType = params.fileType;
    let ownerName = params.ownerName;
    let objectTypes = params.objectTypes;
    try {
        yield _storageManagementService.RequestDeleteActivityFilesAsync({termId, isDeleted, objectTypes, ownerName, fileType, fileDate, fileOwner, fileName, tabName, listName, isAllSelected, S3IdList, IsDeleting })
            .then((responseData: Response) => {
                return responseData;
            })
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                }
                return responseData.json();
            }).then((response) => {
                if (isError) {
                    errorList = response;
                } else {
                    pageData = response;
                }
            });

        if (!isError) {
            Notification.setNotification('success', T.t('r_gen_activity_files_deleted_succes'), 'topRight');
            params.callback();
        } else {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
        }

        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
    } catch (error: any) {
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
        Notification.setNotification('error', '' + error, 'topRight');
    }
}

function* downloadActivityFiles(params: any) {
    let isError = false;
    let errorList: any;
    let pageData: any;
    let S3IdList = params.selectedIds;
    try {
        yield _storageManagementService.RequestDownloadActivityFilesAsync({ S3IdList })
            .then((responseData: Response) => {
                return responseData;
            }).then((response) => {
                if (isError) {
                    errorList = response;
                } else {
                    pageData = response;
                }
            });

        if (!isError) {
            Notification.setNotification('success', T.t('r_gen_activity_files_restored_succes'), 'topRight');
            params.callback();
        } else {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
        }

        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
    } catch (error: any) {
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
        Notification.setNotification('error', '' + error, 'topRight');
    }
}

function* restoreActivityFiles(params: any) {
    let isError = false;
    let errorList: any;
    let pageData: any;
    let S3IdList = params.selectedIds;
    let IsDeleting: boolean = false;
    try {
        yield _storageManagementService.RequestRestoreActivityFilesAsync({ S3IdList, IsDeleting })
            .then((responseData: Response) => {
                return responseData;
            })
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                }
                return responseData.json();
            }).then((response) => {
                if (isError) {
                    errorList = response;
                } else {
                    pageData = response;
                }
            });

        if (!isError) {
            Notification.setNotification('success', T.t('r_gen_activity_files_deleted_succes'), 'topRight');
            params.callback();
        } else {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
        }

        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
    } catch (error: any) {
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
        Notification.setNotification('error', '' + error, 'topRight');
    }
}

function* getCommunicationFilesList(params: any) {
    let isError = false;
    let errorList: any;
    let pageData: any;
    try {
        yield _storageManagementService.RequestGetCommunicationFilesListAsync({ ...params.filters, ...params.paging })
            .then((responseData: Response) => {
                return responseData;
            })
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                }
                return responseData.json();
            }).then((response) => {
                if (isError) {
                    errorList = response;
                } else {
                    pageData = response;
                }
            });

        if (!isError) {
            yield put(storageManagementPageActions.SetCommunicationFilesList(pageData, params.spinnerId ? params.spinnerId : '', 'set'));
        } else {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
        }

        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
    } catch (error: any) {
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
        Notification.setNotification('error', error, 'topRight');
    }
}

function* getCommunicaitonFileStatistics(params: any) {
    let isError = false;
    let errorList: any;
    let pageData: any;
    try {
        yield _storageManagementService.RequestGetCommunicationFilesStatisticsAsync(params)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                }
                return responseData.json();
            }).then((response) => {
                if (isError) {
                    errorList = response;
                } else {
                    pageData = response;
                }
            });

        if (!isError) {
            if(params.callback)
            {
                params.callback()
            }
            yield put(storageManagementPageActions.SetCommunicationFilesStatistics(pageData, params.spinnerId ? params.spinnerId : '', 'set'));
        } else {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
        }

        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
    } catch (error: any) {
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
        Notification.setNotification('error', error, 'topRight');
    }
}

function* getPersonelFilesList(params: any) {
    let isError = false;
    let errorList: any;
    let pageData: any;
    try {
        yield _storageManagementService.RequestGetPersonelFilesListAsync({ ...params.filters, ...params.paging })
            .then((responseData: Response) => {
                return responseData;
            })
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                }
                return responseData.json();
            }).then((response) => {
                if (isError) {
                    errorList = response;
                } else {
                    pageData = response;
                }
            });

        if (!isError) {
            if(params.callback)
            {
                params.callback();
            }
            yield put(storageManagementPageActions.SetPersonelFilesList(pageData, params.spinnerId ? params.spinnerId : '', 'set'));
        } else {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
        }

        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
    } catch (error: any) {
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
        Notification.setNotification('error', error, 'topRight');
    }
}

function* getOtherFilesList(params: any) {
    let isError = false;
    let errorList: any;
    let pageData: any;
    try {
        yield _storageManagementService.RequestGetOtherFilesListAsync({ ...params.filters, ...params.paging })
            .then((responseData: Response) => {
                return responseData;
            })
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                }
                return responseData.json();
            }).then((response) => {
                if (isError) {
                    errorList = response;
                } else {
                    pageData = response;
                }
            });

        if (!isError) {
            if(params.callback)
            {
                params.callback();
            }
            yield put(storageManagementPageActions.SetOtherFilesList(pageData, params.spinnerId ? params.spinnerId : '', 'set'));
        } else {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
        }

        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
    } catch (error: any) {
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
        Notification.setNotification('error', error, 'topRight');
    }
}

//#region "Storage Management Page Saga"

export function* watchGetGeneralStatistics() {
    yield takeEvery(constants.actions.GET_GENERAL_STATISTICS, getGeneralStatistics);
    return null;
}

//#endregion "Storage Management Page End Saga"

//#region "Files Added Activities Saga"

export function* watchFilesAddedActivitiesStatistics() {
    yield takeEvery(constants.actions.GET_FILES_ADDED_ACTIVITIES_STATISTICS, getFilesAddedActivitiesStatistics);
    return null;
}

export function* watchActivityFilesStatisticsByTerm() {
    yield takeEvery(constants.actions.GET_ACTIVITY_FILES_STATISTICS_BYTERM, getActivityFilesStatisticsByTerm);
    return null;
}

export function* watchActivityFilesListByTerm() {
    yield takeEvery(constants.actions.GET_ACTIVITY_FILES_LIST_BYTERM, getActivityFilesListByTerm);
    return null;
}

function* watchDeleteActivityFiles() {
    yield takeEvery(constants.actions.DELETE_ACTIVITY_FILES, deleteActivityFiles);
    return null;
}

function* watchDownloadActivityFiles() {
    yield takeEvery(constants.actions.DOWNLOAD_ACTIVITY_FILES, downloadActivityFiles);
    return null;
}

function* watchRestoreActivityFiles() {
    yield takeEvery(constants.actions.RESTORE_ACTIVITY_FILES, restoreActivityFiles);
    return null;
}

//#endregion "Files Added Activities Saga"

//#region "Comunication Files Saga"

export function* watchCommunicationFiles() {
    yield takeEvery(constants.actions.GET_COMMUNICATION_FILES_LIST, getCommunicationFilesList);
    return null;
}

export function* watchCommunicaitonFilesStatistics() {
    yield takeEvery(constants.actions.GET_COMMUNICATION_FILES_STATISTICS, getCommunicaitonFileStatistics);
    return null;
}

//#endregion "Comunication Files Saga"

//#region "Personel Files Saga"

export function* watchPersonelFiles() {
    yield takeEvery(constants.actions.GET_PERSONEL_FILES_LIST, getPersonelFilesList);
    return null;
}

//#endregion "Personel Files Saga"

//#region "Other Files Saga"

export function* watchOtherFiles() {
    yield takeEvery(constants.actions.GET_OTHER_FILES_LIST, getOtherFilesList);
    return null;
}

//#endregion "Other Files Saga"

export function* StorageManagementSagas() {
    yield all([
        watchGetGeneralStatistics(),
        watchFilesAddedActivitiesStatistics(),
        watchActivityFilesStatisticsByTerm(),
        watchActivityFilesListByTerm(),
        watchDeleteActivityFiles(),
        watchDownloadActivityFiles(),
        watchRestoreActivityFiles(),
        watchCommunicationFiles(),
        watchCommunicaitonFilesStatistics(),
        watchPersonelFiles(),
        watchOtherFiles()
    ]);
}